import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
    Header,
    Footer,
} from '@usb-onboarding/product-recommender-components';
import { resetQuestionnaire } from '../../redux/actions';
import TechnicalDifficulties from '../../molecules/TechnicalDifficulties';

function TechnicalDifficultiesPage() {
    const history = useHistory();
    const dispatch = useDispatch();
    const AEMContent = useSelector(
        (state) => state.AEMContentReducer.AEMContent,
    );

    const error = useSelector((state) => state.errorReducer.error);

    function restartRecommender() {
        dispatch(resetQuestionnaire());
    }

    useEffect(() => {
        if (!error) {
            history.push('/start');
        }
    }, [error]);

    return (
        <>
            <Header title={AEMContent.header.fullName} />
            <main id="app__content">
                <TechnicalDifficulties
                    restartRecommender={restartRecommender}
                />
            </main>
            <Footer
                privacyUrl="https://www.usbank.com/about-us-bank/privacy/privacy-pledge.html"
                content={AEMContent.footer.footerDisclosure}
                fdic=""
            />
        </>
    );
}

export default TechnicalDifficultiesPage;
